import { ITranslations } from "./interfaces";

export const itTranslations: ITranslations = {
  From: "da",
  LatestArrivals: "Ultimi Arrivi",
  LastestArrivalsBreadcrumbs: " Home/Materiali/Ultimi_Arrivi/Blocchi",
  ThicknessShort: "Spess.",
  To: "a",
  Back: "indietro",
  Material: "materiale",
  Filters: "filtri",
  Finish: "finitura",
  Thickness: "spessore",
  ResetFilters: "reset filtri",
  SelectLottoBreadcrumbs_p1: "Home/Materiali/",
  SelectLottoBreadcrumbs_p2: "/Blocchi",
  MaterialType: "tipologia",
  Color: "colore",
  Slabs: "lastre",
  TotalShort: "tot.",
  QuantityShort: "q.tà.",
  FinishShort: "fin",
  Optioned: "opzionati",
  RequestPackingList: "richiedi packing list",
  PackingList: "packing list",
  Print: "stampa",
  Lot: "lotto",
  Measures: "misure",
  Items: "pezzi",
  Warehouse: "magazzino",
  DownloadImage: "scarica immagine",
  ShareLink: "condividi lotto",
  LinkCopiedToClipboard: "link copiato negli appunti",
};
